export default __webpack_public_path__ + "static/media/loading.3794def0.svg";